import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["conditionConfig"];

  connect() {
    // Small delay to ensure form is fully loaded
    setTimeout(() => {
      this.updateConditionConfig();
    }, 100);
  }

  onConditionTypeChange(event) {
    this.updateConditionConfig();
  }

  reset() {
    this.element.reset();
    this.updateConditionConfig();
  }

  updateConditionConfig() {
    const conditionType = this.getConditionType();

    // Hide all condition configs first
    this.conditionConfigTarget.innerHTML = "";

    if (conditionType && conditionType !== "") {
      this.conditionConfigTarget.classList.remove("hidden");
      this.fetchConditionConfig(conditionType);
    } else {
      this.conditionConfigTarget.classList.add("hidden");
    }
  }

  async fetchConditionConfig(conditionType) {
    try {
      const endpointId = this.getEndpointId();
      const url = `/endpoints/${endpointId}/alerts/condition_config?condition_type=${conditionType}`;

      const response = await fetch(url, {
        headers: {
          Accept: "text/html",
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (response.ok) {
        const html = await response.text();
        this.conditionConfigTarget.innerHTML = html;
      }
    } catch (error) {
      console.error("Failed to fetch condition config:", error);
    }
  }

  getConditionType() {
    const select = this.element.querySelector(
      'select[name="alert[condition_type]"]'
    );
    return select ? select.value : "";
  }

  getEndpointId() {
    // Extract endpoint ID from the form action URL
    const form = this.element;
    const action = form.action;
    const match = action.match(/\/endpoints\/([^\/]+)\/alerts/);
    return match ? match[1] : null;
  }
}
